import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Login from "./Login";
import "../styles/Navbar.css";

export default function YeniNavbar() {
  const navigate = useNavigate();
  const userDropdownRef = useRef(null);

  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [user, setUser] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);

  const hoverTimeoutRef = useRef(null);
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");
  const isPersonel = userRole === "personel";

  const onlineMenuText = isPersonel ? "Personel Panelim" : "Fulla Moda Online";
  const onlineMenuPath = isPersonel ? "/profil" : "https://www.fullamoda.com/";

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    let touchStartY = 0;

    const hideNavbar = () => setIsNavbarVisible(false);
    const showNavbar = () => setIsNavbarVisible(true);

    const handleWheel = (e) => {
      if (e.deltaY > 8) hideNavbar();
      if (e.deltaY < -8) showNavbar();
      if (window.scrollY < 10) showNavbar();
    };

    const handleTouchStart = (e) => {
      touchStartY = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
      const currentY = e.touches[0].clientY;
      const diff = touchStartY - currentY;

      if (diff > 12) hideNavbar();
      if (diff < -12) showNavbar();
      if (window.scrollY < 10) showNavbar();
    };

    window.addEventListener("wheel", handleWheel, { passive: true });
    window.addEventListener("touchstart", handleTouchStart, { passive: true });
    window.addEventListener("touchmove", handleTouchMove, { passive: true });

    return () => {
      window.removeEventListener("wheel", handleWheel);
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  useEffect(() => {
    if (!token) return;

    fetchNavbarPhoto();

    const handleProfilePhotoUpdated = () => {
      fetchNavbarPhoto();
    };

    window.addEventListener("profilePhotoUpdated", handleProfilePhotoUpdated);

    return () => {
      window.removeEventListener("profilePhotoUpdated", handleProfilePhotoUpdated);
    };
  }, [token]);

  useEffect(() => {
    let lastY = 0;

    const getCurrentScroll = () => {
      const possibleContainers = [
        document.querySelector(".personel-content"),
        document.querySelector(".personel-container"),
        document.querySelector(".profil-content"),
        document.querySelector(".profil-page"),
      ].filter(Boolean);

      const scrolledContainer = possibleContainers.find(
        (el) => el.scrollTop > 0
      );

      if (scrolledContainer) {
        return scrolledContainer.scrollTop;
      }

      return window.scrollY || document.documentElement.scrollTop || 0;
    };

    const handleScroll = () => {
      const currentY = getCurrentScroll();

      if (currentY > lastY + 8 && currentY > 80) {
        setIsNavbarVisible(false);
      } else if (currentY < lastY - 8) {
        setIsNavbarVisible(true);
      }

      if (currentY < 10) {
        setIsNavbarVisible(true);
      }

      lastY = currentY;
    };

    window.addEventListener("scroll", handleScroll, true);
    document.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
      document.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  const fetchNavbarPhoto = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppbak`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );

      const imgUrl = URL.createObjectURL(res.data);

      setProfilePhoto((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return imgUrl;
      });
    } catch (err) {
      console.error("❌ Navbar profil fotoğrafı alınamadı:", err);
    }
  };

  useEffect(() => {
    const currentUser = localStorage.getItem("user");
    const token = localStorage.getItem("token");

    if (!token) {
      localStorage.removeItem("user");
      localStorage.removeItem("userName");
      localStorage.removeItem("userEmail");
      setUser(null);
      return;
    }

    const checkToken = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/Auth/GetUserIdByToken`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.status === 200) {
          if (currentUser) setUser(JSON.parse(currentUser));
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          localStorage.removeItem("userName");
          localStorage.removeItem("userEmail");
          setUser(null);
        }
      } catch (err) {
        console.error("Token kontrol hatası:", err);
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("userName");
        localStorage.removeItem("userEmail");
        setUser(null);
      }
    };

    checkToken();
  }, []);

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");
      const savedEmail = localStorage.getItem("loginEmail");
      const savedPassword = localStorage.getItem("loginPassword");

      await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/logout`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      localStorage.clear();

      if (savedEmail && savedPassword) {
        localStorage.setItem("loginEmail", savedEmail);
        localStorage.setItem("loginPassword", savedPassword);
      }

      setUser(null);
      setShowLogoutConfirm(false);
      navigate("/");
      window.location.reload();
    } catch (err) {
      console.error("Çıkış hatası:", err);
    }
  };

  return (
    <>
      <nav className={`navbar ${isNavbarVisible ? "visible" : "hidden"}`}>
        <div className="logo-container" onClick={() => navigate("/")}>
          <img
            src="/images/fulla.png"
            className="logo-img"
            alt="Logo"
            style={{ cursor: "pointer" }}
          />
        </div>

        <ul className="nav-links">
          <li>
            <Link to="/about">Hakkımızda</Link>
          </li>

          <li>
            {isPersonel ? (
              <Link to={onlineMenuPath}>{onlineMenuText}</Link>
            ) : (
              <a
                href={onlineMenuPath}
                target="_blank"
                rel="noopener noreferrer"
              >
                {onlineMenuText}
              </a>
            )}
          </li>

          <li>
            <Link to="/joblist">İş İlanları</Link>
          </li>

        </ul>

        <div className="nav-buttons">
          {user ? (
            <div
              className="user-dropdown"
              ref={userDropdownRef}
              onMouseEnter={() => {
                if (window.innerWidth > 768) {
                  clearTimeout(hoverTimeoutRef.current);
                  setDropdownVisible(true);
                }
              }}
              onMouseLeave={() => {
                if (window.innerWidth > 768) {
                  hoverTimeoutRef.current = setTimeout(() => {
                    setDropdownVisible(false);
                  }, 1000);
                }
              }}
            >
              <div className="navbar-user-info">
                {profilePhoto ? (
                  <img
                    src={profilePhoto}
                    alt="Profil"
                    className="navbar-user-photo"
                  />
                ) : (
                  <div className="navbar-user-photo-placeholder">👤</div>
                )}

                <span className="user-name">{user?.adi || "Kullanıcı"}</span>
              </div>

              {dropdownVisible && (
                <div className="modern-user-dropdown">
                  {!isPersonel && (
                    <>
                      <button onClick={() => navigate("/profil")}>
                        Profil
                      </button>

                      <button onClick={() => navigate("/ozgecmisim")}>
                        Özgeçmişim
                      </button>
                    </>
                  )}

                  <button
                    onClick={() => {
                      setShowLogoutConfirm(true);
                      setDropdownVisible(false);
                    }}
                  >
                    Çıkış Yap
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button
              className="login-btn"
              onClick={() => setShowLoginPopup(true)}
            >
              Giriş Yap
            </button>
          )}

          <div className="hamburger-menu" onClick={toggleMobileMenu}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>

        {mobileMenuOpen && (
          <ul className="mobile-nav-links">
            <li>
              <Link to="/about" onClick={closeMobileMenu}>
                Hakkımızda
              </Link>
            </li>

            <li>
              {isPersonel ? (
                <Link to={onlineMenuPath} onClick={closeMobileMenu}>
                  {onlineMenuText}
                </Link>
              ) : (
                <a
                  href={onlineMenuPath}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={closeMobileMenu}
                >
                  {onlineMenuText}
                </a>
              )}
            </li>

            <li>
              <Link to="/joblist" onClick={closeMobileMenu}>
                İş İlanları
              </Link>
            </li>

            {user && (
              <>
                {!isPersonel && (
                  <>
                    <li>
                      <Link to="/profil" onClick={closeMobileMenu}>
                        Profil
                      </Link>
                    </li>

                    <li>
                      <Link to="/ozgecmisim" onClick={closeMobileMenu}>
                        Özgeçmişim
                      </Link>
                    </li>
                  </>
                )}

                <li>
                  <button
                    onClick={() => {
                      closeMobileMenu();
                      setTimeout(() => {
                        setShowLogoutConfirm(true);
                      }, 0);
                    }}
                  >
                    Çıkış Yap
                  </button>
                </li>
              </>
            )}
          </ul>
        )}
      </nav>

      {showLoginPopup && (
        <div
          className="modal-overlay"
          onClick={() => setShowLoginPopup(false)}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="close-btn"
              onClick={() => setShowLoginPopup(false)}
            >
              ✖
            </button>

            <Login onClose={() => setShowLoginPopup(false)} />
          </div>
        </div>
      )}

      {showLogoutConfirm && (
        <div
          className="navbar-logout-overlay"
          onClick={() => setShowLogoutConfirm(false)}
        >
          <div
            className="navbar-logout-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h2>Çıkış yapmak istiyor musunuz?</h2>

            <div className="navbar-logout-actions">
              <button onClick={handleLogout} className="navbar-logout-confirm">
                Evet, Çıkış Yap
              </button>

              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="navbar-logout-cancel"
              >
                Vazgeç
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
